var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',{staticClass:"not-found__header"},[_vm._v(" Oops, something went wrong... ")]),_c('p',{staticClass:"not-found__text"},[_vm._v(" We were unable to load the page settings, please try again ")])])
}]

export { render, staticRenderFns }